export const VideoResolution = {
  p720: 1,
  p1080: 2,
  p4K: 3,
  AskEveryTime: 4,
} as const;

export type VideoResolution =
  (typeof VideoResolution)[keyof typeof VideoResolution];
